import { create } from 'zustand';

type UserState = {
  userId: string | null;
  tenantId: string | null;
  setUser: (userId: string, tenantId: string) => void;
};

export const useUserStore = create<UserState>(set => ({
  userId: null,
  tenantId: null,

  setUser: (userId, tenantId) => {
    set({ userId, tenantId });
  },
}));
